var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2237 21.624C22.2237 22.9423 21.1579 24 19.8296 24C18.5013 24 17.4251 22.9423 17.4251 21.624C17.4251 20.3057 18.5066 19.2375 19.8296 19.2375C21.1631 19.2375 22.2237 20.3057 22.2237 21.624ZM8.89366 19.2375C7.56539 19.2375 6.49962 20.3109 6.49962 21.624C6.49962 22.937 7.56539 24 8.89366 24C10.2219 24 11.2982 22.9423 11.2982 21.624C11.2982 20.3057 10.2219 19.2375 8.89366 19.2375ZM24.2082 5.16891C8.3424 5.16891 4.29983 4.50195 0 0C1.80603 2.69388 2.7983 7.75858 19.5881 7.51368C37.0867 7.25315 26.4132 12 23.3052 17.3565C33.1071 8.67043 40.074 5.16891 24.2082 5.16891Z",
    fill: "#204FB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlue);
export default __webpack_public_path__ + "static/media/cartBlue.e85f9ec0613ab358e8517fd418611b46.svg";
export { ForwardRef as ReactComponent };